"use client";

import { c as _c } from "react/compiler-runtime";
import { Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";
import { Button } from "@/components/ui/button";
export function ModeToggle() {
  const $ = _c(9);
  const {
    theme,
    setTheme,
    systemTheme
  } = useTheme();
  let t0;
  if ($[0] !== setTheme || $[1] !== systemTheme || $[2] !== theme) {
    t0 = () => {
      if (!theme || theme === "system") {
        const opposite = systemTheme === "dark" ? "light" : "dark";
        setTheme(opposite);
      } else {
        setTheme("system");
      }
    };
    $[0] = setTheme;
    $[1] = systemTheme;
    $[2] = theme;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const handleToggle = t0;
  let t1;
  let t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Sun className="h-[1.2rem] w-[1.2rem] rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" />;
    t2 = <Moon className="absolute h-[1.2rem] w-[1.2rem] rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />;
    t3 = <span className="sr-only">Toggle theme</span>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
  }
  let t4;
  if ($[7] !== handleToggle) {
    t4 = <Button className="h-9 w-9" onClick={handleToggle} size="icon" variant="outline">{t1}{t2}{t3}</Button>;
    $[7] = handleToggle;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}